import { defineComponent, ref } from 'vue';
import InfoGraphicListComponent from '@/components/infoGraphicList/InfoGraphicList.vue';
import InfoGraphicFormComponent from '@/components/infoGraphicList/infoGraphicForm/InfoGraphicForm.vue';

export default defineComponent({
  name: 'InfoGraphicComponent',
  components: {
    InfoGraphicListComponent,
    InfoGraphicFormComponent,
  },
  setup: () => {
    const infoGraphicForm = ref<InstanceType<typeof InfoGraphicFormComponent>>();
    const selectedInfo = ref<number | null>();

    const createClick = () => {
      Promise.resolve(selectedInfo.value = null)
        .then(() => infoGraphicForm.value?.show());
    };

    const editClick = (id: number) => {
      Promise.resolve(selectedInfo.value = id)
        .then(() => infoGraphicForm.value?.show());
    };

    return {
      selectedInfo,
      infoGraphicForm,
      createClick,
      editClick,
    };
  },
});
